<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-v-component
          heading="Список логов"
        />
        <base-material-card
          color="primary"
          icon="mdi-script"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Список логов
            </div>
          </template>

          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="datatable_footer"
            :server-items-length="total"
            :options.sync="table_options"
            :loading="loading"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
            </template>
            <template v-slot:top>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      xl="2"
                    >
                      <v-text-field
                        v-model="form.date.from"
                        label="Дата начала"
                        type="date"
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      xl="2"
                    >
                      <v-text-field
                        v-model="form.date.to"
                        label="Дата конца"
                        type="date"
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      xl="2"
                    >
                      <v-select
                        v-model="form.type"
                        label="Тип"
                        :items="select.types"
                        clearable
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      xl="2"
                    >
                      <v-select
                        v-model="form.creator"
                        label="Пользователь"
                        :items="select.users"
                        clearable
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                      xl="2"
                    >
                      <v-text-field
                        v-model="form.entity"
                        label="Объект"
                        type="text"
                        clearable
                        @keyup.enter="load"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="2"
                      xl="1"
                    >
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        @click="load"
                      >
                        Поиск
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-btn
                        color="secondary"
                        dark
                        min-width="250"
                        class="mb-2"
                        @click="clear"
                      >
                        Сбросить фильтры
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                color="primary"
                class="mr-2"
                large
                @click="dialog.item = item, dialog.show = true"
              >
                mdi-eye
              </v-icon>
            </template>
            <template v-slot:item.filter="{ item }">
              <v-icon
                large
                color="primary"
                style="font-size: 26px;"
                @click="form.entity = item.entity, load()"
              >
                mdi-filter-outline
              </v-icon>
              {{ item.state_string }}
            </template>

            <template v-slot:item.date="{item}">
              <div class="table_item">
                <span class="table_item__title">
                  {{ item.date_text }}
                </span>
              </div>
            </template>
            <template v-slot:item.type="{item}">
              <div class="table_item">
                <span class="table_item__title">
                  {{ $store.state.dict.log[item.type] }}
                </span>
              </div>
            </template>
            <template v-slot:item.user="{item}">
              <div class="table_item">
                <span
                  v-if="item.user"
                  class="table_item__title"
                >
                  {{ (item.user.surname ? item.user.surname + " " : "") + item.user.name }}
                </span>
              </div>
            </template>
          </v-data-table>
        </base-material-card>
        <v-dialog
          v-model="dialog.show"
          scrollable
          max-width="80%"
        >
          <v-card class="elevation-1">
            <v-card-title class="headline">
              Просмотр изменений
            </v-card-title>

            <v-card-text>
              <v-switch
                v-model="dialog.diff"
                label="Только различия"
              />
              <div v-if="dialog.diff">
                <pre class="ma-5"><code class="json">{{ dialog.item.diff }}</code></pre>
              </div>
              <div v-else>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <pre class="ma-5"><code class="json">{{ dialog.item.old }}</code></pre>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <pre class="ma-5"><code class="json">{{ dialog.item.change }}</code></pre>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-card-actions class="grey lighten-4">
              <v-btn
                color="primary"
                @click="dialog.show = false"
              >
                Назад
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}

</style>
<script>
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import moment from 'moment'
  import $ from 'jquery'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      table_options: {

      },
      total: 0,
      loading: false,
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
pageText: 'из',
        itemsPerPageAllText: 'Все'
      },
      dialog: {
        show: false,
        diff: true,
        item: {
        },
      },
      headers: [
        {
          sortable: false,
          text: 'Действия',
          value: 'action',
        },
        {
          text: 'Время события',
          value: 'date',
        },
        {
          text: 'Пользователь',
          value: 'user',
        },
        {
          text: 'Тип события',
          value: 'type',
        },
        {
          sortable: false,
          text: 'Фильтровать',
          value: 'filter',
        },
      ],
      items: [],
      search: undefined,
      form: {
        date: {
          from: '',
          to: '',
        },
        type: 0,
        creator: '',
        entity: '',
      },
      select: {
        users: [],
        types: [
          { value: 1, text: 'Создание пользователя' },
          { value: 2, text: 'Изменение пользователя' },
          { value: 3, text: 'Создание события' },
          { value: 4, text: 'Изменение события' },
          { value: 5, text: 'Создание договора' },
          { value: 6, text: 'Изменение договора' },
          { value: 7, text: 'Создание пользователя' },
          { value: 8, text: 'Изменение пользователя' },
          { value: 9, text: 'Регистрация пользователя' },
          { value: 10, text: 'Создание словаря' },
          { value: 11, text: 'Изменение словаря' },
          { value: 12, text: 'Авторизация пользователя' },
          { value: 13, text: 'Создание настройки' },
          { value: 14, text: 'Изменение настройки' },
          { value: 15, text: 'Создание таблицы' },
          { value: 16, text: 'Изменение таблицы' },
          { value: 17, text: 'Создание записи' },
          { value: 18, text: 'Изменение записи' },
          { value: 19, text: 'Ошибка' },
          { value: 20, text: 'Создание документа' },
          { value: 21, text: 'Изменение документа' },
          { value: 22, text: 'Создание папки' },
          { value: 23, text: 'Изменение папки' },
          { value: 24, text: 'Отправка СМС' },
          { value: 25, text: 'Отправка E-mail' },
          { value: 26, text: 'Создание места обслуживания' },
          { value: 27, text: 'Изменение места обслуживания' },
          { value: 28, text: 'Создание устройства' },
          { value: 29, text: 'Изменение устройства' },
          { value: 30, text: 'Создание точки' },
          { value: 31, text: 'Изменение точки' },
          { value: 32, text: 'Создание оператор' },
          { value: 33, text: 'Изменение оператор' },
          { value: 34, text: 'Создание получателя' },
          { value: 35, text: 'Изменение получателя' },
          { value: 36, text: 'Создание товара' },
          { value: 37, text: 'Изменение товара' },
          { value: 38, text: 'Создание заказа' },
          { value: 39, text: 'Изменение заказа' },
          { value: 40, text: 'Создание фискальной операции' },
          { value: 41, text: 'Изменение фискальной операции' },
          { value: 42, text: 'Создание платежа' },
          { value: 43, text: 'Изменение платежа' },
          { value: 44, text: 'Создание плательщика' },
          { value: 45, text: 'Изменение плательщика' },
          { value: 46, text: 'Создание роли' },
          { value: 47, text: 'Изменение роли' },
          { value: 48, text: 'Создание платежа СБП' },
          { value: 49, text: 'Изменение платежа СБП' },
          { value: 54, text: 'Создание номенклатуры' },
          { value: 55, text: 'Изменение номенклатуры' },
        ],

      },
      dict: {
      },
      suggestion: {
        bank_name: false,
        bic: false,
        kpp: false,
        inn: false,
        name: false,
      },
    }),
    watch: {
      table_options: {
        handler () {
          console.log(this.table_options)
          this.$router.push({
            query: {
              page: this.table_options.page,
              limit: this.table_options.itemsPerPage
            }
          })
          this.load()
        },
        deep: true,
      },
    },
    mounted: function () {
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      this.axios.post('/api/user/list/', { all: true })
        .then(response => {
          if (!response.data.error) {
            this.select.users = response.data.data.map(
              function (obj) {
                return { value: obj.id, text: (obj.surname ? obj.surname + ' ' : '') + obj.name }
              }
            )
          } else {
            this.$store.commit('snackbar', response.data.data || 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      const store_filters = JSON.parse(localStorage.getItem('log_filters') ? localStorage.getItem('log_filters') : '{}')

      if (store_filters) {
        if (store_filters.date) {
          if (store_filters.date.from) {
            this.form.date.from = store_filters.date.from
          }
          if (store_filters.date.to) {
            this.form.date.to = store_filters.date.to
          }
        }
        if (store_filters.type) {
          this.form.type = store_filters.type
        }
        if (store_filters.user) {
          this.form.user = store_filters.user
        }
        /*
        if (store_filters.name) {
          this.form.name = store_filters.name
        }
        if (store_filters.number) {
          this.form.number = store_filters.number
        }
        if (store_filters.state) {
          this.form.state = store_filters.state
        }
        if (store_filters.id) {
          this.form.id = store_filters.id
        }
        if (store_filters.deleted) {
          this.form.deleted = store_filters.deleted
        } */
      }

      if (this.$route.query.entity) {
        this.form.entity = this.$route.query.entity
        this.$router.replace({
          query: []
        })
      }
      this.load()
    },
    methods: {
      clear: function () {
        this.form = {
          date: {
            from: '',
            to: '',
          },
          type: 0,
          user: '',
          entity: '',
        },
        this.form.date.from = moment().format('YYYY-MM-DD')
        this.form.date.to = moment().format('YYYY-MM-DD')
        this.load()
      },
      load: function (clear) {
        localStorage.setItem('log_filters', JSON.stringify(this.form))
        const request = JSON.parse(JSON.stringify(this.form))
        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        request.page = page
        request.limit = itemsPerPage
        this.axios.post('/api/log/list', request)
          .then(result => {
            this.loading = false
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              for (const x in this.items) {
                this.items[x].date_text = moment(this.items[x].date).format('DD.MM.YYYY HH:mm')
                this.items[x].diff = diff(JSON.parse(this.items[x].old), JSON.parse(this.items[x].change))
              }
              this.total = result.data.count
            }
          })
          .catch(e => {
            this.loading = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    }
  }
</script>
